import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

export const StaffSizesTable = ({ data }) => {
  return (
    <>
      {data && data.length ? (
        <TableContainer component={Paper}>
          <Table aria-label="Staff Sizes Table">
            <TableHead>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Item</TableCell>
                <TableCell>Size</TableCell>
                <TableCell>Fit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((line) => (
                <TableRow
                  key={line.item}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {line.description}
                  </TableCell>
                  <TableCell>{line.item}</TableCell>
                  <TableCell>{line.size}</TableCell>
                  <TableCell>{line.fit}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <>No Data</>
      )}
    </>
  );
};
